import { useNavigate, useLocation } from "react-router-dom";
import { useLocationScope } from "@/context/LocationContext";
import { useAuth } from "@/context/AuthContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { MapPin, Globe } from "lucide-react";

export default function LocationSwitcher() {
  const { lots, selectedLot, setSelectedLot, ALL } = useLocationScope();
  const { user } = useAuth();
  const canAll = ["owner", "manager"].includes(user?.role);
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (value) => {
    setSelectedLot(value);
    // Only the Live Board / Portfolio swap routes when scope changes. Other
    // pages (Activity, Monthly Accounts, Settings) filter in place.
    const onBoardish =
      location.pathname === "/board" || location.pathname === "/dashboard";
    if (onBoardish) navigate(value === ALL ? "/dashboard" : "/board");
  };

  return (
    <Select value={selectedLot} onValueChange={handleChange}>
      <SelectTrigger
        data-testid="location-switcher"
        className="h-11 w-[210px] border-slate-700 bg-slate-900 text-base font-semibold text-slate-100"
      >
        <div className="flex items-center gap-2">
          {selectedLot === ALL ? (
            <Globe className="h-4 w-4 text-[#A0148C]" />
          ) : (
            <MapPin className="h-4 w-4 text-[#A0148C]" />
          )}
          <SelectValue placeholder="Select location" />
        </div>
      </SelectTrigger>
      <SelectContent className="border-slate-700 bg-slate-900 text-slate-100">
        {canAll && (
          <>
            <SelectItem value={ALL} data-testid="location-option-all">
              All Locations
            </SelectItem>
            <SelectSeparator className="bg-slate-700" />
          </>
        )}
        {lots.map((l) => (
          <SelectItem key={l.id} value={l.id} data-testid={`location-option-${l.id}`}>
            {l.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
